import React from "react";
import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { ISSUES_PERMS_ACTIONS } from "../../enum";
import {
    ISSUE_CONVERSATION_DELETE_PERMISSION,
    ISSUE_CONVERSATION_UPDATE_PERMISSION,
} from "components/dashboard/TrainSAM/SAM/WorkflowSettings/permissions";

const IssuesTableDropdown = ({ issue, handleActionModal }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal(value, issue)}
            options={[
                {
                    value: ISSUES_PERMS_ACTIONS.EDIT_ISSUE,
                    label: "Edit Issue",
                    baseResources: ISSUE_CONVERSATION_UPDATE_PERMISSION,
                },
                {
                    value: ISSUES_PERMS_ACTIONS.DELETE_ISSUE,
                    label: "Delete Isssue",
                    baseResources: ISSUE_CONVERSATION_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default IssuesTableDropdown;
